module.exports = __webpack_public_path__ + "adf195e4be.woff";